export default __webpack_public_path__ + "static/phone-0b11e5eeb23548572c86b2f3e84d75cf.png";